import React from 'react';
import { Polyline } from 'react-leaflet';

function RouteLayer({ route }) {
  return (
    <Polyline
      positions={route.geometry.coordinates}
      color="blue"
      weight={2}
    />
  );
}

export default RouteLayer;